<template>
  <div class="form-group" :key="dateKey">
    <div
      class="form-group"
      v-for="(institution, index) in officesArr"
      v-if="institution.offices"
      :key="index">
      <label
        v-if="institution.offices.length !== 0"
        class="mb-3 mt-3 font-weight-bold">
        {{ institution.name }}
      </label>
      <div class="form-group">
        <div
          v-for="(office, indexOffice) in institution.offices"
          :key="indexOffice">
          <d-checkbox
            :value="'1'"
            :checked="String"
            :unchecked-value="'0'"
            :class="'mb-4'"
            v-model="office.office_used"
            toggle>
            {{office.office_name}}
          </d-checkbox>
          <div class="form-group" v-if="office.office_used === 1 || office.office_used === '1'">
            <div>
              <div style="display: flex">
                <d-checkbox
                  v-if="days[0].monday"
                  :checked="String"
                  :value="'1'"
                  :unchecked-value="'0'"
                  v-model="office.is_open_1">
                {{ days[0].monday }}
                </d-checkbox>
              </div>
              <div class="mt-3 mb-1 titleHours border-top pt-3 pb-3" v-if="office.is_open_1 === 1 || office.is_open_1 === '1'">
                {{ label }}
              </div>
              <div class="form-group border-bottom pb-3" style="display: flex;" v-if="office.is_open_1 === 1 || office.is_open_1 === '1'">
                <div class="form-group">
                <span
                  v-for="(date, indexFrom) in office.work_day_1_from"
                  :key="'from-' + indexFrom">
                  <div class="mt-4" :style="`'margin-top: 10px;`">
                    Rozpoczęcie pracy: TEST
                  </div>
                    <date-picker
                      class="mt-2 daysAndHours-date"
                      v-model="office.work_day_1_from[indexFrom]"
                      :time-picker-options="intervalFlexStart1[0]"
                      format="HH:mm"
                      valueType="format"
                      type="time"
                      :placeholder="'Start'"
                    ></date-picker>
                  </span>
                </div>
                <div class="form-group">
                  <span v-for="(date, indexTo) in office.work_day_1_to" :key="'to-' + indexTo">
                    <div class="ml-4 mt-4" :style="`'margin-top: 10px;`">
                      Zakończenie pracy:
                    </div>
                    <span style="display: flex">
                      <date-picker
                        class="ml-4 mt-2 daysAndHours-date"
                        v-model="office.work_day_1_to[indexTo]"
                        :time-picker-options="intervalFlexEnd1[0]"
                        format="HH:mm"
                        valueType="format"
                        type="time"
                        :placeholder="'Koniec'"
                      ></date-picker>
                      <d-button
                        :disabled="office.work_day_1_to[indexTo] === '' || office.work_day_1_from[indexTo] === '' || office.work_day_1_to[indexTo] === null || office.work_day_1_from[indexTo] === null"
                        class="ml-4 function-buttons"
                        style="width: 175px;"
                        theme="primary"
                        @click.prevent="addNextLine(1, office.work_day_1_to[indexTo], index, indexOffice)">
                      <i class="material-icons">add</i>
                        Dodaj
                      </d-button>
                      <d-button
                        v-if="indexTo !== 0"
                        class="ml-4 function-buttons"
                        style="width: 175px;"
                        theme="danger"
                        @click.prevent="removeLine(1, indexTo, index, indexOffice)">
                        <i class="material-icons">close</i>
                        Usuń
                      </d-button>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div>
              <div style="display: flex">
                <d-checkbox
                  v-if="days[0].tuesday"
                  :checked="String"
                  :value="'1'"
                  :unchecked-value="'0'"
                  v-model="office.is_open_2"
                >
                {{ days[0].tuesday }}
                </d-checkbox>
              </div>
              <div class="mt-3 mb-1 titleHours border-top pt-3 pb-3" v-if="office.is_open_2 === 1 || office.is_open_2 === '1'">
                {{ label }}
              </div>
              <div class="form-group border-bottom pb-3" style="display: flex;" v-if="office.is_open_2 === 1 || office.is_open_2 === '1'">
                <div class="form-group">
                <span
                  v-for="(date, indexFrom) in office.work_day_2_from"
                  :key="'from-' + indexFrom">
                  <div class="mt-4" :style="`'margin-top: 10px;`">
                    Rozpoczęcie pracy:
                  </div>
                    <date-picker
                      class="mt-2 daysAndHours-date"
                      v-model="office.work_day_2_from[indexFrom]"
                      :time-picker-options="intervalFlexStart2[0]"
                      format="HH:mm"
                      valueType="format"
                      type="time"
                      :placeholder="'Start'"
                    ></date-picker>
                  </span>
                </div>
                <div class="form-group">
                  <span v-for="(date, indexTo) in office.work_day_2_to" :key="'to-' + indexTo">
                    <div class="ml-4 mt-4" :style="`'margin-top: 10px;`">
                      Zakończenie pracy:
                    </div>
                    <span style="display: flex">
                      <date-picker
                        class="ml-4 mt-2 daysAndHours-date"
                        v-model="office.work_day_2_to[indexTo]"
                        :time-picker-options="intervalFlexEnd2[0]"
                        format="HH:mm"
                        valueType="format"
                        type="time"
                        :placeholder="'Koniec'"
                      ></date-picker>
                      <d-button
                        :disabled="office.work_day_2_to[indexTo] === '' || office.work_day_2_from[indexTo] === '' || office.work_day_2_to[indexTo] === null || office.work_day_2_from[indexTo] === null"
                        class="ml-4 function-buttons"
                        style="width: 175px;"
                        theme="primary"
                        @click.prevent="addNextLine(2, office.work_day_2_to[indexTo], index, indexOffice)">
                      <i class="material-icons">add</i>
                        Dodaj
                      </d-button>
                      <d-button
                        v-if="indexTo !== 0"
                        class="ml-4 function-buttons"
                        style="width: 175px;"
                        theme="danger"
                        @click.prevent="removeLine(2, indexTo, index, indexOffice)">
                        <i class="material-icons">close</i>
                        Usuń
                      </d-button>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div>
              <div style="display: flex">
                <d-checkbox
                  v-if="days[0].wednesday"
                  :checked="String"
                  :value="'1'"
                  :unchecked-value="'0'"
                  v-model="office.is_open_3"
                >
                {{ days[0].wednesday }}
                </d-checkbox>
              </div>
              <div class="mt-3 mb-1 titleHours border-top pt-3 pb-3" v-if="office.is_open_3 === 1 || office.is_open_3 === '1'">
                {{ label }}
              </div>
              <div class="form-group border-bottom pb-3" style="display: flex;" v-if="office.is_open_3 === 1 || office.is_open_3 === '1'">
                <div class="form-group">
                <span
                  v-for="(date, indexFrom) in office.work_day_3_from"
                  :key="'from-' + indexFrom">
                  <div class="mt-4" :style="`'margin-top: 10px;`">
                    Rozpoczęcie pracy:
                  </div>
                    <date-picker
                      class="mt-2 daysAndHours-date"
                      v-model="office.work_day_3_from[indexFrom]"
                      :time-picker-options="intervalFlexStart3[0]"
                      format="HH:mm"
                      valueType="format"
                      type="time"
                      :placeholder="'Start'"
                    ></date-picker>
                  </span>
                </div>
                <div class="form-group">
                  <span v-for="(date, indexTo) in office.work_day_3_to" :key="'to-' + indexTo">
                    <div class="ml-4 mt-4" :style="`'margin-top: 10px;`">
                      Zakończenie pracy:
                    </div>
                    <span style="display: flex">
                      <date-picker
                        class="ml-4 mt-2 daysAndHours-date"
                        v-model="office.work_day_3_to[indexTo]"
                        :time-picker-options="intervalFlexEnd3[0]"
                        format="HH:mm"
                        valueType="format"
                        type="time"
                        :placeholder="'Koniec'"
                      ></date-picker>
                      <d-button
                        :disabled="office.work_day_3_to[indexTo] === '' || office.work_day_3_from[indexTo] === '' || office.work_day_3_to[indexTo] === null || office.work_day_3_from[indexTo] === null"
                        class="ml-4 function-buttons"
                        style="width: 175px;"
                        theme="primary"
                        @click.prevent="addNextLine(3, office.work_day_3_to[indexTo], index, indexOffice)">
                      <i class="material-icons">add</i>
                        Dodaj
                      </d-button>
                      <d-button
                        v-if="indexTo !== 0"
                        class="ml-4 function-buttons"
                        style="width: 175px;"
                        theme="danger"
                        @click.prevent="removeLine(3, indexTo, index, indexOffice)">
                        <i class="material-icons">close</i>
                        Usuń
                      </d-button>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div>
              <div style="display: flex">
                <d-checkbox
                  v-if="days[0].thursday"
                  :checked="String"
                  :value="'1'"
                  :unchecked-value="'0'"
                  v-model="office.is_open_4"
                >
                {{ days[0].thursday }}
                </d-checkbox>
              </div>
              <div class="mt-3 mb-1 titleHours border-top pt-3 pb-3" v-if="office.is_open_4 === 1 || office.is_open_4 === '1'">
                {{ label }}
              </div>
              <div class="form-group border-bottom pb-3" style="display: flex;" v-if="office.is_open_4 === 1 || office.is_open_4 === '1'">
                <div class="form-group">
                <span
                  v-for="(date, indexFrom) in office.work_day_4_from"
                  :key="'from-' + indexFrom">
                  <div class="mt-4" :style="`'margin-top: 10px;`">
                    Rozpoczęcie pracy:
                  </div>
                    <date-picker
                      class="mt-2 daysAndHours-date"
                      v-model="office.work_day_4_from[indexFrom]"
                      :time-picker-options="intervalFlexStart4[0]"
                      format="HH:mm"
                      valueType="format"
                      type="time"
                      :placeholder="'Start'"
                    ></date-picker>
                  </span>
                </div>
                <div class="form-group">
                  <span v-for="(date, indexTo) in office.work_day_4_to" :key="'to-' + indexTo">
                    <div class="ml-4 mt-4" :style="`'margin-top: 10px;`">
                      Zakończenie pracy:
                    </div>
                    <span style="display: flex">
                      <date-picker
                        class="ml-4 mt-2 daysAndHours-date"
                        v-model="office.work_day_4_to[indexTo]"
                        :time-picker-options="intervalFlexEnd4[0]"
                        format="HH:mm"
                        valueType="format"
                        type="time"
                        :placeholder="'Koniec'"
                      ></date-picker>
                      <d-button
                        :disabled="office.work_day_4_to[indexTo] === '' || office.work_day_4_from[indexTo] === '' || office.work_day_4_to[indexTo] === null || office.work_day_4_from[indexTo] === null"
                        class="ml-4 function-buttons"
                        style="width: 175px;"
                        theme="primary"
                        @click.prevent="addNextLine(4, office.work_day_4_to[indexTo], index, indexOffice)">
                      <i class="material-icons">add</i>
                        Dodaj
                      </d-button>
                      <d-button
                        v-if="indexTo !== 0"
                        class="ml-4 function-buttons"
                        style="width: 175px;"
                        theme="danger"
                        @click.prevent="removeLine(4, indexTo, index, indexOffice)">
                        <i class="material-icons">close</i>
                        Usuń
                      </d-button>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div>
              <div style="display: flex">
                <d-checkbox
                  v-if="days[0].friday"
                  :checked="String"
                  :value="'1'"
                  :unchecked-value="'0'"
                  v-model="office.is_open_5"
                >
                {{ days[0].friday }}
                </d-checkbox>
              </div>
              <div class="mt-3 mb-1 titleHours border-top pt-3 pb-3" v-if="office.is_open_5 === 1 || office.is_open_5 === '1'">
                {{ label }}
              </div>
              <div class="form-group border-bottom pb-3" style="display: flex;" v-if="office.is_open_5 === 1 || office.is_open_5 === '1'">
                <div class="form-group">
                <span
                  v-for="(date, indexFrom) in office.work_day_5_from"
                  :key="'from-' + indexFrom">
                  <div class="mt-4" :style="`'margin-top: 10px;`">
                    Rozpoczęcie pracy:
                  </div>
                    <date-picker
                      class="mt-2 daysAndHours-date"
                      v-model="office.work_day_5_from[indexFrom]"
                      :time-picker-options="intervalFlexStart5[0]"
                      format="HH:mm"
                      valueType="format"
                      type="time"
                      :placeholder="'Start'"
                    ></date-picker>
                  </span>
                </div>
                <div class="form-group">
                  <span v-for="(date, indexTo) in office.work_day_5_to" :key="'to-' + indexTo">
                    <div class="ml-4 mt-4" :style="`'margin-top: 10px;`">
                      Zakończenie pracy:
                    </div>
                    <span style="display: flex">
                      <date-picker
                        class="ml-4 mt-2 daysAndHours-date"
                        v-model="office.work_day_5_to[indexTo]"
                        :time-picker-options="intervalFlexEnd5[0]"
                        format="HH:mm"
                        valueType="format"
                        type="time"
                        :placeholder="'Koniec'"
                      ></date-picker>
                      <d-button
                        :disabled="office.work_day_5_to[indexTo] === '' || office.work_day_5_from[indexTo] === '' || office.work_day_5_to[indexTo] === null || office.work_day_5_from[indexTo] === null"
                        class="ml-4 function-buttons"
                        style="width: 175px;"
                        theme="primary"
                        @click.prevent="addNextLine(5, office.work_day_5_to[indexTo], index, indexOffice)">
                      <i class="material-icons">add</i>
                        Dodaj
                      </d-button>
                      <d-button
                        v-if="indexTo !== 0"
                        class="ml-4 function-buttons"
                        style="width: 175px;"
                        theme="danger"
                        @click.prevent="removeLine(5, indexTo, index, indexOffice)">
                        <i class="material-icons">close</i>
                        Usuń
                      </d-button>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div>
              <div style="display: flex">
                <d-checkbox
                  v-if="days[0].saturday"
                  :checked="String"
                  :value="'1'"
                  :unchecked-value="'0'"
                  v-model="office.is_open_6"
                >
                {{ days[0].saturday }}
                </d-checkbox>
              </div>
              <div class="mt-3 mb-1 titleHours border-top pt-3 pb-3" v-if="office.is_open_6 === 1 || office.is_open_6 === '1'">
                {{ label }}
              </div>
              <div class="form-group border-bottom pb-3" style="display: flex;" v-if="office.is_open_6 === 1 || office.is_open_6 === '1'">
                <div class="form-group">
                <span
                  v-for="(date, indexFrom) in office.work_day_6_from"
                  :key="'from-' + indexFrom">
                  <div class="mt-4" :style="`'margin-top: 10px;`">
                    Rozpoczęcie pracy:
                  </div>
                    <date-picker
                      class="mt-2 daysAndHours-date"
                      v-model="office.work_day_6_from[indexFrom]"
                      :time-picker-options="intervalFlexStart6[0]"
                      format="HH:mm"
                      valueType="format"
                      type="time"
                      :placeholder="'Start'"
                    ></date-picker>
                  </span>
                </div>
                <div class="form-group">
                  <span v-for="(date, indexTo) in office.work_day_6_to" :key="'to-' + indexTo">
                    <div class="ml-4 mt-4" :style="`'margin-top: 10px;`">
                      Zakończenie pracy:
                    </div>
                    <span style="display: flex">
                      <date-picker
                        class="ml-4 mt-2 daysAndHours-date"
                        v-model="office.work_day_6_to[indexTo]"
                        :time-picker-options="intervalFlexEnd6[0]"
                        format="HH:mm"
                        valueType="format"
                        type="time"
                        :placeholder="'Koniec'"
                      ></date-picker>
                      <d-button
                        :disabled="office.work_day_6_to[indexTo] === '' || office.work_day_6_from[indexTo] === '' || office.work_day_6_to[indexTo] === null || office.work_day_6_from[indexTo] === null"
                        class="ml-4 function-buttons"
                        style="width: 175px;"
                        theme="primary"
                        @click.prevent="addNextLine(6, office.work_day_6_to[indexTo], index, indexOffice)">
                      <i class="material-icons">add</i>
                        Dodaj
                      </d-button>
                      <d-button
                        v-if="indexTo !== 0"
                        class="ml-4 function-buttons"
                        style="width: 175px;"
                        theme="danger"
                        @click.prevent="removeLine(6, indexTo, index, indexOffice)">
                        <i class="material-icons">close</i>
                        Usuń
                      </d-button>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div>
              <div style="display: flex">
                <d-checkbox
                  v-if="days[0].sunday"
                  :checked="String"
                  :value="'1'"
                  :unchecked-value="'0'"
                  v-model="office.is_open_7"
                >
                {{ days[0].sunday }}
                </d-checkbox>
              </div>
              <div class="mt-3 mb-1 titleHours border-top pt-3 pb-3" v-if="office.is_open_7 === 1 || office.is_open_7 === '1'">
                {{ label }}
              </div>
              <div class="form-group border-bottom pb-3" style="display: flex;" v-if="office.is_open_7 === 1 || office.is_open_7 === '1'">
                <div class="form-group">
                <span
                  v-for="(date, indexFrom) in office.work_day_7_from"
                  :key="'from-' + indexFrom">
                  <div class="mt-4" :style="`'margin-top: 10px;`">
                    Rozpoczęcie pracy:
                  </div>
                    <date-picker
                      class="mt-2 daysAndHours-date"
                      v-model="office.work_day_7_from[indexFrom]"
                      :time-picker-options="intervalFlexStart7[0]"
                      format="HH:mm"
                      valueType="format"
                      type="time"
                      :placeholder="'Start'"
                    ></date-picker>
                  </span>
                </div>
                <div class="form-group">
                  <span v-for="(date, indexTo) in office.work_day_7_to" :key="'to-' + indexTo">
                    <div class="ml-4 mt-4" :style="`'margin-top: 10px;`">
                      Zakończenie pracy:
                    </div>
                    <span style="display: flex">
                      <date-picker
                        class="ml-4 mt-2 daysAndHours-date"
                        v-model="office.work_day_7_to[indexTo]"
                        :time-picker-options="intervalFlexEnd7[0]"
                        format="HH:mm"
                        valueType="format"
                        type="time"
                        :placeholder="'Koniec'"
                      ></date-picker>
                      <d-button
                        :disabled="office.work_day_7_to[indexTo] === '' || office.work_day_7_from[indexTo] === '' || office.work_day_7_to[indexTo] === null || office.work_day_7_from[indexTo] === null"
                        class="ml-4 function-buttons"
                        style="width: 175px;"
                        theme="primary"
                        @click.prevent="addNextLine(7, office.work_day_7_to[indexTo], index, indexOffice)">
                      <i class="material-icons">add</i>
                        Dodaj
                      </d-button>
                      <d-button
                        v-if="indexTo !== 0"
                        class="ml-4 function-buttons"
                        style="width: 175px;"
                        theme="danger"
                        @click.prevent="removeLine(7, indexTo, index, indexOffice)">
                        <i class="material-icons">close</i>
                        Usuń
                      </d-button>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Vue from 'vue';

export default {
  name: 'days-and-hours-two',
  components: { DatePicker },
  computed: {
    isEdit () {
      return !!this.userId;
    },
  },
  data () {
    return {
      schedules: [],
      dropIndex: '',
      disableAddButton1: false,
      disableAddButton2: false,
      disableAddButton3: false,
      disableAddButton4: false,
      disableAddButton5: false,
      disableAddButton6: false,
      disableAddButton7: false,
      offices: {
        data: {}
      },
      officesArr: {
        offices: {
          office_id: '',
          office_used: '',
          is_open_1: '',
          work_day_1_from: [],
          work_day_1_to: [],
          is_open_2: '',
          work_day_2_from: [],
          work_day_2_to: [],
          is_open_3: '',
          work_day_3_from: [],
          work_day_3_to: [],
          is_open_4: '',
          work_day_4_from: [],
          work_day_4_to: [],
          is_open_5: '',
          work_day_5_from: [],
          work_day_5_to: [],
          is_open_6: '',
          work_day_6_from: [],
          work_day_6_to: [],
          is_open_7: '',
          work_day_7_from: [],
          work_day_7_to: [],
        }
      },
      officesNew: [],
      dateKey: 1,
      interval: ['08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00'],
      intervalFlexStart: {
        data: {
          data: {}
        }
      },
      intervalFlexEnd: {
        data: {
          data: {}
        }
      },
      intervalFlexStart1: [{
        start: '07:00',
        step: '00:30',
        end: '20:30'
      }],
      intervalFlexStart2: [{
        start: '07:00',
        step: '00:30',
        end: '20:30'
      }],
      intervalFlexStart3: [{
        start: '07:00',
        step: '00:30',
        end: '20:30'
      }],
      intervalFlexStart4: [{
        start: '07:00',
        step: '00:30',
        end: '20:30'
      }],
      intervalFlexStart5: [{
        start: '07:00',
        step: '00:30',
        end: '20:30'
      }],
      intervalFlexStart6: [{
        start: '07:00',
        step: '00:30',
        end: '20:30'
      }],
      intervalFlexStart7: [{
        start: '07:00',
        step: '00:30',
        end: '20:30'
      }],
      intervalFlexEnd1: [{
        start: '07:30',
        step: '00:30',
        end: '21:00'
      }],
      intervalFlexEnd2: [{
        start: '07:30',
        step: '00:30',
        end: '21:00'
      }],
      intervalFlexEnd3: [{
        start: '07:30',
        step: '00:30',
        end: '21:00'
      }],
      intervalFlexEnd4: [{
        start: '07:30',
        step: '00:30',
        end: '21:00'
      }],
      intervalFlexEnd5: [{
        start: '07:30',
        step: '00:30',
        end: '21:00'
      }],
      intervalFlexEnd6: [{
        start: '07:30',
        step: '00:30',
        end: '21:00'
      }],
      intervalFlexEnd7: [{
        start: '07:30',
        step: '00:30',
        end: '21:00'
      }],
      upgradeAttempt: false,
    }
  },
  props: {
    loadItems: {
      type: [Array, Object],
      required: true
    },
    label: {
      type: String,
      default: 'Podaj godziny urządowania:'
    },
    refresh: {
      type: Function,
      required: true
    },
    save: {
      type: Boolean,
      required: true
    },
    externalData: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      required: true
    },
    days: {
      type: Array,
      default: () => [
        {
          monday: 'Poniedziałek',
          tuesday: 'Wtorek',
          wednesday: 'Środa',
          thursday: 'Czwartek',
          friday: 'Piątek',
          saturday: 'Sobota',
          sunday: 'Niedziela',
        }
      ]
    },
  },
  watch: {
    'save': function () {
      if (this.externalData === false) {
        this.submitScheduleStore();
      }
    },
    'loadItems': function (value) {
      this.checkValue(value)
    },
    officesArr (data) {
      this.validate(data);
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.loadItems.length) {
        this.officesArr = this.loadItems;
      }
    }, 800)
  },
  methods: {
    validate (data) {
      this.$emit('input', data);
    },
    checkValue (value) {
      const items = value;
      for (let i = 0; i < items.length; i++) {
        for (let j = 0; j < items[i].offices.length; j++) {
          if (items[i].offices[j].office_used === '1') {
            this.upgradeAttempt = true
          }
        }
      }
    },
    addNextLine (number, timeTo, index, indexOffice) {
      let indexEnd = '';
      for (let i = 0; i < this.interval.length; i++) {
        if (this.interval[i] === timeTo && this.interval[i] !== 26) {
          indexEnd = i + 1
        }
      }
      this.dropIndex = indexEnd;
      if (this.dropIndex !== '') {
        if (number === 1) {
          if (indexEnd <= 26) {
            this.officesArr[index].offices[indexOffice].work_day_1_from.push('1');
            this.officesArr[index].offices[indexOffice].work_day_1_to.push('1');
            this.dateKey += 1;
            this.intervalFlexStart1.push({
              start: this.interval[this.dropIndex],
              step: '00:30',
              end: '20:30'
            });
            this.intervalFlexEnd1.push({
              start: this.interval[this.dropIndex + 1],
              step: '00:30',
              end: '21:00'
            })
          } else {
            this.disableAddButton1 = true
          }
        }
        if (number === 2) {
          if (indexEnd <= 26) {
            this.officesArr[index].offices[indexOffice].work_day_2_from.push('1');
            this.officesArr[index].offices[indexOffice].work_day_2_to.push('1');
            this.dateKey += 1;
            this.intervalFlexStart2.push({
              start: this.interval[this.dropIndex],
              step: '00:30',
              end: '20:30'
            });
            this.intervalFlexEnd2.push({
              start: this.interval[this.dropIndex + 1],
              step: '00:30',
              end: '21:00'
            })
          } else {
            this.disableAddButton2 = true
          }
        }
        if (number === 3) {
          if (indexEnd <= 26) {
            this.officesArr[index].offices[indexOffice].work_day_3_from.push('1');
            this.officesArr[index].offices[indexOffice].work_day_3_to.push('1');
            this.dateKey += 1;
            this.intervalFlexStart3.push({
              start: this.interval[this.dropIndex],
              step: '00:30',
              end: '20:30'
            });
            this.intervalFlexEnd3.push({
              start: this.interval[this.dropIndex + 1],
              step: '00:30',
              end: '21:00'
            })
          } else {
            this.disableAddButton3 = true
          }
        }
        if (number === 4) {
          if (indexEnd <= 26) {
            this.officesArr[index].offices[indexOffice].work_day_4_from.push('1');
            this.officesArr[index].offices[indexOffice].work_day_4_to.push('1');
            this.dateKey += 1;
            this.intervalFlexStart4.push({
              start: this.interval[this.dropIndex],
              step: '00:30',
              end: '20:30'
            });
            this.intervalFlexEnd4.push({
              start: this.interval[this.dropIndex + 1],
              step: '00:30',
              end: '21:00'
            })
          } else {
            this.disableAddButton4 = true
          }
        }
        if (number === 5) {
          if (indexEnd <= 26) {
            this.officesArr[index].offices[indexOffice].work_day_5_from.push('1');
            this.officesArr[index].offices[indexOffice].work_day_5_to.push('1');
            this.dateKey += 1;
            this.intervalFlexStart5.push({
              start: this.interval[this.dropIndex],
              step: '00:30',
              end: '20:30'
            });
            this.intervalFlexEnd5.push({
              start: this.interval[this.dropIndex + 1],
              step: '00:30',
              end: '21:00'
            })
          } else {
            this.disableAddButton5 = true
          }
        }
        if (number === 6) {
          if (indexEnd <= 26) {
            this.officesArr[index].offices[indexOffice].work_day_6_from.push('1');
            this.officesArr[index].offices[indexOffice].work_day_6_to.push('1');
            this.dateKey += 1;
            this.intervalFlexStart6.push({
              start: this.interval[this.dropIndex],
              step: '00:30',
              end: '20:30'
            });
            this.intervalFlexEnd6.push({
              start: this.interval[this.dropIndex + 1],
              step: '00:30',
              end: '21:00'
            })
          } else {
            this.disableAddButton6 = true
          }
        }
        if (number === 7) {
          if (indexEnd <= 26) {
            this.officesArr[index].offices[indexOffice].work_day_7_from.push('1');
            this.officesArr[index].offices[indexOffice].work_day_7_to.push('1');
            this.dateKey += 1;
            this.intervalFlexStart7.push({
              start: this.interval[this.dropIndex],
              step: '00:30',
              end: '20:30'
            });
            this.intervalFlexEnd7.push({
              start: this.interval[this.dropIndex + 1],
              step: '00:30',
              end: '21:00'
            })
          } else {
            this.disableAddButton7 = true
          }
        }
      }
    },
    removeLine (number, indexTo, index, indexOffice) {
      if (number === 1 && indexTo !== 0) {
        this.officesArr[index].offices[indexOffice].work_day_1_from.splice(indexTo, 1);
        this.officesArr[index].offices[indexOffice].work_day_1_to.splice(indexTo, 1);
        this.intervalFlexStart1.splice(indexTo, 1);
        this.intervalFlexEnd1.splice(indexTo, 1);
      }
      if (number === 2 && indexTo !== 0) {
        this.officesArr[index].offices[indexOffice].work_day_2_from.splice(indexTo, 1);
        this.officesArr[index].offices[indexOffice].work_day_2_to.splice(indexTo, 1);
        this.intervalFlexStart2.splice(indexTo, 1);
        this.intervalFlexEnd2.splice(indexTo, 1);
      }
      if (number === 3 && indexTo !== 0) {
        this.officesArr[index].offices[indexOffice].work_day_3_from.splice(indexTo, 1);
        this.officesArr[index].offices[indexOffice].work_day_3_to.splice(indexTo, 1);
        this.intervalFlexStart3.splice(indexTo, 1);
        this.intervalFlexEnd3.splice(indexTo, 1);
      }
      if (number === 4 && indexTo !== 0) {
        this.officesArr[index].offices[indexOffice].work_day_4_from.splice(indexTo, 1);
        this.officesArr[index].offices[indexOffice].work_day_4_to.splice(indexTo, 1);
        this.intervalFlexStart4.splice(indexTo, 1);
        this.intervalFlexEnd4.splice(indexTo, 1);
      }
      if (number === 5 && indexTo !== 0) {
        this.officesArr[index].offices[indexOffice].work_day_5_from.splice(index, 1);
        this.officesArr[index].offices[indexOffice].work_day_5_to.splice(index, 1);
        this.intervalFlexStart5.splice(index, 1);
        this.intervalFlexEnd5.splice(index, 1);
      }
      if (number === 6 && indexTo !== 0) {
        this.officesArr[index].offices[indexOffice].work_day_6_from.splice(indexTo, 1);
        this.officesArr[index].offices[indexOffice].work_day_6_to.splice(indexTo, 1);
        this.intervalFlexStart6.splice(indexTo, 1);
        this.intervalFlexEnd6.splice(indexTo, 1);
      }
      if (number === 7 && indexTo !== 0) {
        this.officesArr[index].offices[indexOffice].work_day_7_from.splice(indexTo, 1);
        this.officesArr[index].offices[indexOffice].work_day_7_to.splice(indexTo, 1);
        this.intervalFlexStart7.splice(indexTo, 1);
        this.intervalFlexEnd7.splice(indexTo, 1);
      }
    },
    submitScheduleStore () {
      let formDataToSend = this.prepareFormDataToSend();
      this.$http.post('/schedules/users/store', formDataToSend).then(() => {
        this.refresh()
      }).catch((error) => {
        console.log(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas zapisywania terminarza',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
          buttonsStyling: true
        });
      });
    },
    prepareFormDataToSend () {
      return {
        user_id: this.userId,
        institutions: this.officesArr
      };
    },
  }
}
</script>

<style lang="scss">
  .daysAndHours-date {
    max-width: 13rem;
  }
  .function-buttons {
    max-width: 7.5rem;
    width: 175px;
    height: 2.3rem;
    margin-top: 0.5rem;
  }
  .titleHours {
    font-size: 1.3rem;
    color: #868e96;
    font-weight: 600;
  }
  .saveButton {
    margin-left: auto;
    display: list-item;
    margin-top: -2rem;
    width: 20%;
  }
</style>
